import { Dropdown, Menu, Tooltip } from "antd";
import { CellRenderers } from "utils/tableUtils"
import { DownOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import Vocabulary from "components/Vocabulary";
import _ from "lodash";

const TOOLTIPS = {
    "Bug": <><strong>Bug</strong> is a coding error that will break your code or change the outcome and needs to be fixed immediately.</>,
    "Code Smell": <><strong>Code Smell</strong> is a maintainability issue or weaknesses in design that makes your code confusing and difficult to maintain and increase the risk of bugs or failures in the future.</>,
    "Vulnerability": <><strong>Vulnerability</strong> is a point in your code that's open to attack or high on risk and needs immediate attention to get it fixed.</>,
    "Security Hotspot": <><strong>Security Hotspot</strong> highlights a security-sensitive piece of code that the developer needs to review and triage as they may hide a vulnerability.</>,
    "Compliance": <><strong>Compliance</strong> means conforming to a rule, such as a specification, policy, standard or law. Regulatory compliance describes the goal that organizations aspire to achieve in their efforts to ensure that they are aware of and take steps to comply with relevant laws, policies, and regulations. </>
};

export const useFetchCategories = () => {
    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true);
        const { promise, cancel } = GlobalSettingAPI.getCustomizedCategory();
        promise
            .then((res) => {
                setCategoryList(!_.isEmpty(res) ? res : [])
            })
            .catch(console.log).finally(() => setLoading(false));
        return cancel;
    }, []);

    return { loading, categoryList }

}

export const ArmorcodeCategory = ({category, onChange, disabled}) => {
    const {  loading, categoryList } = useFetchCategories();
    const menu = (
        <Menu onClick={onChange} style={{ maxHeight: 300, overflow: 'auto' }}>
            {
                categoryList.map((entry) => <Menu.Item key={entry}>
                    {TOOLTIPS[entry] ? <Tooltip placement="right" title={TOOLTIPS[entry]}>
                        <div>
                            { entry }
                        </div>
                    </Tooltip> : entry}
                </Menu.Item>
                )
            }
        </Menu>
    )
    
    return <Dropdown
    loading={loading}
    disabled={disabled}
    overlay={menu}
    trigger={['click']}
>
    <div className='d-flex align-items-center'>
        <span className="text-ellipsis m-r-xs">{CellRenderers.VALUE_OR_NA(category)}</span>
        <DownOutlined />
    </div>
</Dropdown>
}

export const ArmorcodeCategoryDefinitions = () => <Vocabulary name="category" />